// extracted by mini-css-extract-plugin
export var shake = "_f-0";